import { render, staticRenderFns } from "./featured.vue?vue&type=template&id=118aee87"
import script from "./featured.vue?vue&type=script&lang=js"
export * from "./featured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports